/**
 * Open a URL in the user's default browser.
 *
 * In Electron the preload exposes `window.tcCrm.openExternal` which uses the
 * main process's `shell.openExternal` so the user's system browser handles
 * the navigation (and the renderer's BrowserWindow is never repurposed).
 *
 * In a hosted web build there is no preload - fall back to `window.open`
 * with `noopener,noreferrer` so the opened tab can't access window.opener.
 */
export function openExternal(url: string): void {
  const tcCrm = (
    window as unknown as { tcCrm?: { openExternal?: (u: string) => unknown } }
  ).tcCrm;
  if (tcCrm?.openExternal) {
    tcCrm.openExternal(url);
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}

/**
 * Detect whether the renderer is running inside the packaged Electron shell
 * (the preload has injected `window.tcCrm`) vs. as a standalone web app.
 * Used to gate Electron-only UI affordances (e.g. file dialogs that rely on
 * the IPC bridge) and to enable web-only flows (SSO redirect handling).
 */
export function isElectron(): boolean {
  return typeof window !== 'undefined' && !!(window as { tcCrm?: unknown }).tcCrm;
}
